<app-base-list-page
  [headersList]="headerList"
  (rowClick)="agreementClicked($event)"
  [extraBurgerMenuOptions]="extraBurgerMenuOptions"
  [multiSelectFilterLists]="multiSelectFilterLists"
  [createNew]="agreementClicked"
  newItemLabel="Ny aftale"
  #baseListPage
></app-base-list-page>
